import type { AppModule } from '@/core/types';

import * as routes from './routes';

export const AnalyzerModule: AppModule = {
  routes,
};
